import { render, staticRenderFns } from "./compsAuditLogModalTableTitle.vue?vue&type=template&id=5341f4e9&scoped=true"
import script from "./compsAuditLogModalTableTitle.vue?vue&type=script&lang=js"
export * from "./compsAuditLogModalTableTitle.vue?vue&type=script&lang=js"
import style0 from "./compsAuditLogModalTableTitle.vue?vue&type=style&index=0&id=5341f4e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5341f4e9",
  null
  
)

export default component.exports